import React from 'react';
import styles from './RoutePageSkeleton.module.css';

export default function RoutePageSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSkeleton} />
        <div className={styles.metaSkeleton} />
      </div>

      <div className={styles.statsGrid}>
        <div className={styles.cardSkeleton} />
        <div className={styles.cardSkeleton} />
        <div className={styles.cardSkeleton} />
      </div>

      <div className={styles.sectionSkeleton}>
        <div className={styles.labelSkeleton} />
        <div className={styles.textSkeleton} />
      </div>

      <div className={styles.sectionSkeleton}>
        <div className={styles.labelSkeleton} />
        <div className={styles.textSkeleton} />
        <div className={styles.textSkeleton} />
        <div className={styles.textSkeleton} />
      </div>
    </div>
  );
}
